export var QuizPageStrings = {
    pageTitle: {
        shortQuiz: function () { return 'Take a short quiz to identify the right solution for you'; },
        recommendation: function () { return 'Here is what we recommend for your team'; },
    },
    actionButton: {
        continue: function () { return 'Continue'; },
        finish: function () { return 'Finish'; },
        startOver: function () { return 'Start Over'; },
    },
    questions: {
        whereIsTeam: {
            question: function () { return 'Where is your team?'; },
            option1: {
                title: function () { return 'Remote'; },
                subtitle: function () { return 'Distributed home offices'; },
            },
            option2: {
                title: function () { return 'In Office'; },
                subtitle: function () { return 'Centrally located in offices'; },
            },
            option3: {
                title: function () { return 'Hybrid'; },
                subtitle: function () { return 'A mix of remote and in offices'; },
            },
        },
        howOften: {
            question: function () { return 'How often would you like to provide meals?'; },
            option1: {
                title: function () { return 'Just one time'; },
            },
            option2: {
                title: function () { return 'Monthly'; },
            },
            option3: {
                title: function () { return 'Weekly or more'; },
            },
        },
        workEmail: {
            question: function () { return 'What is your work email?'; },
            label: function () { return 'Your Work Email'; },
        },
    },
    recommendations: {
        catering: {
            title: function () { return 'Catering'; },
            subtitle: function () {
                return 'Set-up a DoorDash account to access convenient catering options.';
            },
            body1: {
                title: function () { return 'How We Do Catering'; },
                bullet1: function () { return 'Easily select catering friendly restaurants'; },
                bullet2: function () {
                    return 'Choose from a large selection of individually packaged items (or tray catering)';
                },
            },
            body2: {
                title: function () { return 'What We Offer'; },
                bullet1: function () {
                    return 'Live order monitoring with live support from specialists, you can focus on your work';
                },
                bullet2: function () { return 'Access the highest rated Dashers that we hand-pick'; },
                bullet3: function () { return 'Priority customer support'; },
            },
            buttonText: function () { return 'Order Now'; },
        },
        expensedMeals: {
            title: function () { return 'Expensed Meals'; },
            subtitle: function () { return 'Provide your team DoorDash meal credits'; },
            body1: {
                title: function () { return 'Team Meals'; },
                bullet1: function () {
                    return 'Enroll your team by signing up and adding your team to the Work Portal';
                },
                bullet2: function () {
                    return 'Set ordering rules by customizing your budget, delivery dates/times and locations';
                },
                bullet3: function () {
                    return 'Enjoy the best of DoorDash. Let your team order from hundredds of thousands of restaurants';
                },
            },
            body2: {
                title: function () { return 'What We Offer'; },
                bullet1: function () {
                    return 'Create multiple budgets with multiple groups. Easily add in your employees and create sub-groups each with their own budgets';
                },
                bullet2: function () {
                    return 'Expense with ease by accessing all your billing and monthly reports through our work portal + concur integration';
                },
            },
            pricing: {
                title: function () { return 'Pricing'; },
                subtitle: function () {
                    return 'Our Work Portals are free to use, we simply charge standard order processing and delivery fees';
                },
            },
            buttonText: function () { return 'Enroll Now'; },
        },
    },
};
